import { render, staticRenderFns } from "./EmailCollector.vue?vue&type=template&id=23363ff4&scoped=true"
import script from "./EmailCollector.vue?vue&type=script&lang=js"
export * from "./EmailCollector.vue?vue&type=script&lang=js"
import style0 from "./EmailCollector.vue?vue&type=style&index=0&id=23363ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23363ff4",
  null
  
)

export default component.exports